export class Messages{
    StatusCode:number;
    isWarning:boolean;
    isError:boolean;
    isSuccess:boolean;
    isInfo:boolean;
    Message:string;
    ErrorCode:number;
}